var scope = require('scope');
var $ = scope.$ = require('jquery');
scope.app = require('./app');
require('./libs/ajax');

var eventMap = require('./libs/metrics');

$(document).ready(function () {
    scope.app.start();

    $(document).on('click', '[data-metrics]', function (e) {
        var ev = $(e.currentTarget).data('metrics');
        var metric = eventMap[ev];

        var label = $(e.currentTarget).data('metrics-label') ? $(e.currentTarget).data('metrics-label') : metric.label;
        var value = $(e.currentTarget).data('metrics-value') ? $(e.currentTarget).data('metrics-value') : metric.value;

        if (ev) {
            ga('send', 'event', metric.category, metric.action, label, value);
            // ga('send', 'event', metric.category, metric.action, label);
        }
    });
});



//////////////////
// WEBPACK FOOTER
// ./resources/assets/site/scripts/main.js
// module id = 222
// module chunks = 3